/* eslint-disable import/no-cycle */
import ContentGroupLineController from './content-group-line-controller'

export default ContentGroupLineController
